import React from "react";
import { Alert, Collapse } from "@mui/material";
import { INCENTIVE_RECALCULATION_WARNING } from "@/constants";

type Props = {
  show: boolean;
  sx?: object;
};

/**
 * The inline notice shown when an admin edits data the incentive is derived from (SDCP-1305).
 *
 * It only warns. Saving the form leaves the stored incentive untouched; changing it is a
 * separate, deliberate action on the project details page.
 */
const IncentiveImpactWarning = ({ show, sx }: Props) => (
  <Collapse in={show} unmountOnExit>
    <Alert
      severity="warning"
      data-testid="incentive-impact-warning"
      sx={{ mb: 3, borderRadius: "8px", fontSize: "14px", ...sx }}
    >
      {INCENTIVE_RECALCULATION_WARNING}
    </Alert>
  </Collapse>
);

export default IncentiveImpactWarning;
